import { Component, OnInit} from '@angular/core';
import { environment } from 'environments/environment';
import { NotificationsService } from 'app/modules/shared/services/notifications.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { UiService } from 'app/modules/shared/services/ui.service';


@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {
  shibbolethLogoutUrl;
  constructor(private notificationsService: NotificationsService,
    private storageService: StorageService,
    private uiService: UiService) { }

  ngOnInit() {
    this.notificationsService.canFetchNotification = false;
    // this.shibbolethSessionLogout();
    this.clearStorage();
    this.uiService.profileUpdated();
  }

  clearStorage() {
    this.storageService.removeAll();
  }

  // shibbolethSessionLogout() {
  //   this.shibbolethLogoutUrl = environment.logoutUrl;
  // }

  onLogin() {
    // window.location.href = environment.loginUrl;
  }

}
